import React from 'react'
import styled, { css } from 'styled-components'
import {
  InfoIcon,
  TickIcon,
  WarningIcon,
  CloseOutlineIcon as ErrorIcon
} from '@mote/assets/icons'
import { P } from '../typography/text'
import { Block } from '../block/block'

const ICONS_MAP = {
  error: <ErrorIcon />,
  warn: <WarningIcon />,
  success: <TickIcon />,
  info: <InfoIcon />
}

export const Alert = ({
  className,
  message,
  type = 'error',
  fontSize = 15,
  style = {}
}) => {
  return (
    <Root
      layout='horizontal'
      align='center'
      gap={8}
      type={type}
      className={className}
      style={style}
    >
      {React.cloneElement(ICONS_MAP[type], {
        color: 'currentColor',
        width: 24,
        height: 24
      })}
      <P fontSize={fontSize} lineHeight='120%' fontWeight='normal'>
        {message}
      </P>
    </Root>
  )
}

const Root = styled(Block)`
  min-height: 40px;
  width: 100%;
  padding: 8px 16px;
  border-radius: 8px;
  margin-bottom: 8px;

  svg {
    flex: 0 0 auto;
  }

  ${({ type }) => {
    switch (type) {
      case 'error':
        return css`
          color: #f44336;
          background: rgba(244, 67, 54, 0.1);
        `
      case 'warn':
        return css`
          color: #feb43b;
          background: rgba(254, 180, 59, 0.1);
        `
      case 'success':
        return css`
          color: #57c96a;
          background: rgba(87, 201, 106, 0.1);
        `
      case 'info':
        return css`
          color: #3649f4;
          background: rgba(54, 73, 244, 0.1);
        `
      default:
        console.error('[Alert] Wrong type provided')
    }
  }}
`
